export const non_geopath_data = [
    {
        'Display Owner': 'Zoom Media (USA)',
        'Display Format': 'Health and Beauty|Gyms',
        Plays: 420911,
        'DSP Impressions': 13587904.31,
        'DSP IM': 32.28,
        'Average IM': 29.01,
        'IM VAR': -3.27,
        '% VAR': '-10.13%',
    },
    {
        'Display Owner': 'GSTV',
        'Display Format': 'Retail|Gas Stations',
        Plays: 9774377,
        'DSP Impressions': 12259057.68,
        'DSP IM': 1.25,
        'Average IM': 1.26,
        'IM VAR': 0.01,
        '% VAR': '0.80%',
    },
    {
        'Display Owner': 'Volta Charging',
        'Display Format': 'Outdoor|Urban Panels',
        Plays: 9880531,
        'DSP Impressions': 5346255.312,
        'DSP IM': 0.54,
        'Average IM': 0.85,
        'IM VAR': 0.31,
        '% VAR': '57.41%',
    },
    {
        'Display Owner': 'International Outdoor',
        'Display Format': 'Outdoor|Billboards',
        Plays: 138325,
        'DSP Impressions': 4839112.093,
        'DSP IM': 34.98,
        'Average IM': 19.71,
        'IM VAR': -15.27,
        '% VAR': '-43.65%',
    },
    {
        'Display Owner': 'Screenverse',
        'Display Format': 'Offices|Office Buildings',
        Plays: 607020,
        'DSP Impressions': 3161569.25,
        'DSP IM': 5.21,
        'Average IM': 2.73,
        'IM VAR': -2.48,
        '% VAR': '-47.60%',
    },
    {
        'Display Owner': 'Captivate',
        'Display Format': 'Offices|Office Buildings',
        Plays: 314534,
        'DSP Impressions': 2603757.51,
        'DSP IM': 8.28,
        'Average IM': 2.73,
        'IM VAR': -5.55,
        '% VAR': '-67.03%',
    },
    {
        'Display Owner': 'Vengo Labs',
        'Display Format': 'Offices|Office Buildings',
        Plays: 1639311,
        'DSP Impressions': 2463938.197,
        'DSP IM': 1.5,
        'Average IM': 2.73,
        'IM VAR': 1.23,
        '% VAR': '82.00%',
    },
    {
        'Display Owner': 'Adams',
        'Display Format': 'Outdoor|Billboards',
        Plays: 153107,
        'DSP Impressions': 2049724.64,
        'DSP IM': 13.39,
        'Average IM': 19.71,
        'IM VAR': 6.32,
        '% VAR': '47.20%',
    },
    {
        'Display Owner': 'Smartify Media',
        'Display Format': 'Outdoor|Urban Panels',
        Plays: 143097,
        'DSP Impressions': 1604584,
        'DSP IM': 11.21,
        'Average IM': 0.85,
        'IM VAR': -10.36,
        '% VAR': '-92.42%',
    },
    {
        'Display Owner': 'Blip Billboards',
        'Display Format': 'Outdoor|Billboards',
        Plays: 93857,
        'DSP Impressions': 1248875.045,
        'DSP IM': 13.31,
        'Average IM': 19.71,
        'IM VAR': 6.4,
        '% VAR': '48.08%',
    },
    {
        'Display Owner': 'Orange Barrel Media',
        'Display Format': 'Outdoor|Urban Panels',
        Plays: 654493,
        'DSP Impressions': 1237208.25,
        'DSP IM': 1.89,
        'Average IM': 0.85,
        'IM VAR': -1.04,
        '% VAR': '-55.03%',
    },
    {
        'Display Owner': 'Corner Media',
        'Display Format': 'Outdoor|Urban Panels',
        Plays: 142360,
        'DSP Impressions': 708054.38,
        'DSP IM': 4.97,
        'Average IM': 0.85,
        'IM VAR': -4.12,
        '% VAR': '-82.90%',
    },
    {
        'Display Owner': 'Lamar',
        'Display Format': 'Outdoor|Billboards',
        Plays: 55603,
        'DSP Impressions': 550211.4725,
        'DSP IM': 9.9,
        'Average IM': 19.71,
        'IM VAR': 9.81,
        '% VAR': '99.09%',
    },
    {
        'Display Owner': 'Vertical Impression - US',
        'Display Format': 'Offices|Office Buildings',
        Plays: 357215,
        'DSP Impressions': 468408,
        'DSP IM': 1.31,
        'Average IM': 2.73,
        'IM VAR': 1.42,
        '% VAR': '108.40%',
    },
    {
        'Display Owner': 'Gabi Media',
        'Display Format': 'Offices|Office Buildings',
        Plays: 416365,
        'DSP Impressions': 416365,
        'DSP IM': 1,
        'Average IM': 2.73,
        'IM VAR': 1.73,
        '% VAR': '173.00%',
    },
    {
        'Display Owner': 'RoveIQ',
        'Display Format': 'Outdoor|Urban Panels',
        Plays: 124187,
        'DSP Impressions': 316347.5578,
        'DSP IM': 2.55,
        'Average IM': 0.85,
        'IM VAR': -1.7,
        '% VAR': '-66.67%',
    },
    {
        'Display Owner': 'Atmosphere',
        'Display Format': 'Health and Beauty|Gyms',
        Plays: 26389,
        'DSP Impressions': 268889.4,
        'DSP IM': 10.19,
        'Average IM': 29.01,
        'IM VAR': 18.82,
        '% VAR': '184.69%',
    },
    {
        'Display Owner': 'Bulletin Displays',
        'Display Format': 'Outdoor|Billboards',
        Plays: 17527,
        'DSP Impressions': 266642.03,
        'DSP IM': 15.21,
        'Average IM': 19.71,
        'IM VAR': 4.5,
        '% VAR': '29.59%',
    },
    {
        'Display Owner': 'Orange Barrel Media',
        'Display Format': 'Outdoor|Billboards',
        Plays: 3686,
        'DSP Impressions': 154812,
        'DSP IM': 42,
        'Average IM': 19.71,
        'IM VAR': -22.29,
        '% VAR': '-53.07%',
    },
    {
        'Display Owner': 'Vengo Labs',
        'Display Format': 'Outdoor|Urban Panels',
        Plays: 135756,
        'DSP Impressions': 85252.98,
        'DSP IM': 0.63,
        'Average IM': 0.85,
        'IM VAR': 0.22,
        '% VAR': '34.92%',
    },
    {
        'Display Owner': 'Starlite Digital',
        'Display Format': 'Outdoor|Urban Panels',
        Plays: 52182,
        'DSP Impressions': 68065.88988,
        'DSP IM': 1.3,
        'Average IM': 0.85,
        'IM VAR': -0.45,
        '% VAR': '-34.62%',
    },
    {
        'Display Owner': 'Intersection',
        'Display Format': 'Outdoor|Urban Panels',
        Plays: 10020,
        'DSP Impressions': 48998.16682,
        'DSP IM': 4.89,
        'Average IM': 0.85,
        'IM VAR': -4.04,
        '% VAR': '-82.62%',
    },
    {
        'Display Owner': 'Liquid Outdoor',
        'Display Format': 'Outdoor|Urban Panels',
        Plays: 16219,
        'DSP Impressions': 32388.7988,
        'DSP IM': 2,
        'Average IM': 0.85,
        'IM VAR': -1.15,
        '% VAR': '-57.50%',
    },
    {
        'Display Owner': 'Shelf Nine',
        'Display Format': 'Retail|Gas Stations',
        Plays: 14862,
        'DSP Impressions': 29724,
        'DSP IM': 2,
        'Average IM': 1.26,
        'IM VAR': -0.74,
        '% VAR': '-37.00%',
    },
    {
        'Display Owner': 'Screenverse + Apparatix Billboards',
        'Display Format': 'Outdoor|Billboards',
        Plays: 1036,
        'DSP Impressions': 19931.14177,
        'DSP IM': 19.24,
        'Average IM': 19.71,
        'IM VAR': 0.47,
        '% VAR': '2.44%',
    },
    {
        'Display Owner': 'Vengo Labs',
        'Display Format': 'Health and Beauty|Gyms',
        Plays: 15312,
        'DSP Impressions': 19786.7,
        'DSP IM': 1.29,
        'Average IM': 29.01,
        'IM VAR': 27.72,
        '% VAR': '2148.84%',
    },
    {
        'Display Owner': 'Gabi Media',
        'Display Format': 'Health and Beauty|Gyms',
        Plays: 16115,
        'DSP Impressions': 16115,
        'DSP IM': 1,
        'Average IM': 29.01,
        'IM VAR': 28.01,
        '% VAR': '2801.00%',
    },
    {
        'Display Owner': 'Loop Media',
        'Display Format': 'Offices|Office Buildings',
        Plays: 1906,
        'DSP Impressions': 10176,
        'DSP IM': 5.34,
        'Average IM': 2.73,
        'IM VAR': -2.61,
        '% VAR': '-48.88%',
    },
    {
        'Display Owner': 'Screenverse',
        'Display Format': 'Outdoor|Urban Panels',
        Plays: 2357,
        'DSP Impressions': 5892.5,
        'DSP IM': 2.5,
        'Average IM': 0.85,
        'IM VAR': -1.65,
        '% VAR': '-66.00%',
    },
    {
        'Display Owner': 'Dover Fueling Solutions',
        'Display Format': 'Retail|Gas Stations',
        Plays: 1539,
        'DSP Impressions': 1540,
        'DSP IM': 1,
        'Average IM': 1.26,
        'IM VAR': 0.26,
        '% VAR': '26.00%',
    },
    {
        'Display Owner': 'True Sync Media',
        'Display Format': 'Offices|Office Buildings',
        Plays: 74,
        'DSP Impressions': 944.721,
        'DSP IM': 12.77,
        'Average IM': 12.77,
        'IM VAR': 0,
        '% VAR': '0.00%',
    },
    {
        'Display Owner': 'Fuel Media TV',
        'Display Format': 'Retail|Gas Stations',
        Plays: 240,
        'DSP Impressions': 515.30188,
        'DSP IM': 2.15,
        'Average IM': 1.26,
        'IM VAR': -0.89,
        '% VAR': '-41.40%',
    },
    {
        'Display Owner': 'Loop Media',
        'Display Format': 'Health and Beauty|Gyms',
        Plays: 111,
        'DSP Impressions': 460,
        'DSP IM': 4.14,
        'Average IM': 29.01,
        'IM VAR': 24.87,
        '% VAR': '600.72%',
    },
];

export const geopathData = [
    {
        'Display Owner': 'Outfront Media',
        'Display Format': 'Outdoor|Billboards',
        Plays: 741469,
        'DSP Impressions': 14991906.35,
        'Geopath Impressions': 14571020.67,
        VAR: -420885.68,
        'DSP IM': 20.21919508,
        'Geopath IM': 19.65155748,
        'IM VAR': -0.5676376,
        '% VAR': '-2.81%',
    },
    {
        'Display Owner': 'Clear Channel',
        'Display Format': 'Outdoor|Billboards',
        Plays: 309242,
        'DSP Impressions': 12787591.09,
        'Geopath Impressions': 12476920.58,
        VAR: -310670.51,
        'DSP IM': 41.3514047,
        'Geopath IM': 40.3467853,
        'IM VAR': -1.0046194,
        '% VAR': '-2.43%',
    },
    {
        'Display Owner': 'Lamar',
        'Display Format': 'Outdoor|Billboards',
        Plays: 288023,
        'DSP Impressions': 4914640.327,
        'Geopath Impressions': 3830365.328,
        VAR: -1084274.999,
        'DSP IM': 17.06336066,
        'Geopath IM': 13.29881755,
        'IM VAR': -3.76454311,
        '% VAR': '-22.06%',
    },
    {
        'Display Owner': 'Orange Barrel Media',
        'Display Format': 'Outdoor|Urban Panels',
        Plays: 650627,
        'DSP Impressions': 592867.48,
        'Geopath Impressions': 1303037.766,
        VAR: 710170.286,
        'DSP IM': 0.911224834,
        'Geopath IM': 2.002741611,
        'IM VAR': 1.091516777,
        '% VAR': '119.79%',
    },
    {
        'Display Owner': 'Intersection Media',
        'Display Format': 'Outdoor|Urban Panels',
        Plays: 257829,
        'DSP Impressions': 488033.276,
        'Geopath Impressions': 339148.5641,
        VAR: -148884.7119,
        'DSP IM': 1.892856413,
        'Geopath IM': 1.315401154,
        'IM VAR': -0.577455259,
        '% VAR': '-30.51%',
    },
    {
        'Display Owner': 'WOW Media',
        'Display Format': 'Outdoor|Billboards',
        Plays: 4564,
        'DSP Impressions': 81668.96305,
        'Geopath Impressions': 399898.584,
        VAR: 318229.621,
        'DSP IM': 17.89416368,
        'Geopath IM': 87.62019807,
        'IM VAR': 69.72603439,
        '% VAR': '389.66%',
    },
    {
        'Display Owner': 'Big Outdoor',
        'Display Format': 'Outdoor|Billboards',
        Plays: 369,
        'DSP Impressions': 17158.0602,
        'Geopath Impressions': 15275.75624,
        VAR: -1882.30396,
        'DSP IM': 46.49880813,
        'Geopath IM': 41.39771339,
        'IM VAR': -5.10109474,
        '% VAR': '-10.97%',
    },
];
